"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../../utils");

/**
 * An `ApiResult` object contains response information about an API request.
 */
var ApiResult =
/** @class */
function () {
  /**
   * Initializes a result instance with the necessary response information.
   *
   * @param {*} response
   * @param {*} data
   * @param {*} error
   * @param {*} [params=null]
   * @memberof ApiResult
   */
  function ApiResult(response, data, error, params) {
    if (params === void 0) {
      params = null;
    }

    var warning = null; // move error info to the warning property if the code is prefixed by `warn_`

    if (error) {
      var code = (error || {}).code;

      if (/^warn_/.test(code)) {
        warning = error;
      }
    }

    this.response = response;
    this.data = data;
    this.error = (0, _utils.isset)(warning) ? null : error;
    this.warning = warning;
    this.params = params;
  }
  /**
   * Returns the headers returned by the response, if any.
   *
   * @returns {*}
   * @memberof ApiResult
   */


  ApiResult.prototype.headers = function () {
    return this.response ? this.response.headers : undefined;
  };

  return ApiResult;
}();

var _default = ApiResult;
exports.default = _default;
module.exports = exports.default;